import type { FC } from "react";
import { ASSISTANT_AVATAR } from "../../../../../theme/tokens";
import { AssistantCharacterAccessory } from "../../assistantAvatarConfig";
import { AvatarCoffee } from "../shared/AvatarCoffee";
import { AvatarFlower } from "../shared/AvatarFlower";
import { AvatarGlasses } from "../shared/AvatarGlasses";
import { AvatarShades } from "../shared/AvatarShades";

const { ACCESSORY } = ASSISTANT_AVATAR;

const Cap: FC = () => (
	<>
		<path d="M24 42 C24 16 42 5 60 5 C78 5 96 16 96 42 C82 33 38 33 24 42Z" fill={ACCESSORY.CAP} />
		<path d="M24 42 C38 33 82 33 96 42" fill="none" stroke={ACCESSORY.CAP_BRIM} strokeWidth={3} />
		{[
			[44, 20],
			[60, 15],
			[76, 20],
		].map(([cx, cy]) => (
			<circle key={cx} cx={cx} cy={cy} r={2} fill={ACCESSORY.CAP_DOT} />
		))}
	</>
);

const Stethoscope: FC = () => (
	<>
		<path d="M36 84 Q38 99 60 99 Q82 99 84 84" fill="none" stroke={ACCESSORY.INK} strokeWidth={3} strokeLinecap="round" />
		<path d="M60 99 V103" stroke={ACCESSORY.INK} strokeWidth={3} />
		<circle cx={60} cy={107} r={5.5} fill={ACCESSORY.CHEST_PIECE} stroke={ACCESSORY.INK} strokeWidth={2.5} />
	</>
);

const Headphones: FC = () => (
	<>
		<path d="M18 60 C18 18 102 18 102 60" fill="none" stroke={ACCESSORY.INK} strokeWidth={5} strokeLinecap="round" />
		{[10, 96].map((x) => (
			<rect key={x} x={x} y={52} width={14} height={22} rx={6} fill={ACCESSORY.HEADPHONE_CUP} stroke={ACCESSORY.INK} strokeWidth={2.5} />
		))}
	</>
);

const ACCESSORIES: Record<AssistantCharacterAccessory, FC | null> = {
	[AssistantCharacterAccessory.None]: null,
	[AssistantCharacterAccessory.Cap]: Cap,
	[AssistantCharacterAccessory.Glasses]: AvatarGlasses,
	[AssistantCharacterAccessory.Shades]: AvatarShades,
	[AssistantCharacterAccessory.Stethoscope]: Stethoscope,
	[AssistantCharacterAccessory.Headphones]: Headphones,
	[AssistantCharacterAccessory.Coffee]: AvatarCoffee,
	[AssistantCharacterAccessory.Flower]: () => <AvatarFlower transform="translate(88 22)" />,
};

export const CharacterAccessory: FC<{ accessory: AssistantCharacterAccessory }> = ({ accessory }) => {
	const Accessory = ACCESSORIES[accessory];
	return Accessory ? <Accessory /> : null;
};
